__turbopack_context__.v({
  "card": "InsightsCards-module-scss-module__kNx8sG__card",
  "cardContent": "InsightsCards-module-scss-module__kNx8sG__cardContent",
  "cardsWrapper": "InsightsCards-module-scss-module__kNx8sG__cardsWrapper",
  "component": "InsightsCards-module-scss-module__kNx8sG__component",
  "date": "InsightsCards-module-scss-module__kNx8sG__date",
  "headerRow": "InsightsCards-module-scss-module__kNx8sG__headerRow",
  "heading": "InsightsCards-module-scss-module__kNx8sG__heading",
  "imageWrapper": "InsightsCards-module-scss-module__kNx8sG__imageWrapper",
  "subtitle": "InsightsCards-module-scss-module__kNx8sG__subtitle",
  "title": "InsightsCards-module-scss-module__kNx8sG__title",
  "viewAllBtn": "InsightsCards-module-scss-module__kNx8sG__viewAllBtn",
  "viewAllBtnMobile": "InsightsCards-module-scss-module__kNx8sG__viewAllBtnMobile",
});
